// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MIT
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

import { API_KEY } from '@app/core/environment.configuration';

import { ContractRequest, ContractResponse, OnboardingResponse } from '@app/core/models';
import { delay } from 'rxjs/operators';

@Injectable()
export class ContractService {
  constructor(private httpClient: HttpClient, @Inject(API_KEY) private api: string) {}

  public post(details: ContractRequest): Observable<ContractResponse> {
    const route = `${this.api}/membership-onboarding/contract`;
    return this.httpClient.post<ContractResponse>(route, details);
  }

  public submit(envelopeId: string): Observable<OnboardingResponse> {
    const mockResponse: OnboardingResponse = {
      envelopeId,
      statusCode: 200,
      message: 'success!',
      entities: {
        'Account.Id': '001J0000021vz6HIAQ',
        'Opportunity.Id': '006J000000ZTVcGIAX',
        'Opportunity.Name': 'Automotive Grade Linux Premium Membership - Two Bulls',
        contacts: [
          {
            'Contact.Id': '003J000001d48VLIAY',
            'Contact.Email': 'lfx-eng@twobulls.com'
          }
        ]
      }
    };
    return of(mockResponse).pipe(delay(1500));
  }
}



// WEBPACK FOOTER //
// ./src/app/core/services/contract.service.ts